import React from 'react';
import { FormInstance } from 'antd/es/form';
import { RadioChangeEvent } from 'antd/lib/radio';
import { EUserType } from 'enums/base.enum';
import { Form, Radio, Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, device } from 'GlobalStyles';

const { Text, Title } = Typography;
const SelectTypeWrapper = styled.div`
  .mentor-type-button,
  .mentee-type-button {
    max-width: 300px;
    width: 100%;
    height: 300px;
    margin-right: 20px;
    margin-top: 10px;
    padding: 20px;
    border-radius: 8px !important;
    border: none;
    h3.ant-typography {
      color: #fff;
    }
    @media screen and ${device.lg} {
      height: 200px;
      margin: 10px auto;
      display: block;
    }
  }
  .mentor-type-button {
    background: ${PrimaryColor};
  }
  .mentee-type-button {
    background: #3cac40;
  }
  .user-type-content {
    font-size: 18px;
    color: #fff;
    opacity: 50%;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    background-color: transparent;
  }
`;
type TSelectTypeProps = {
  form: FormInstance;
};
const SelectType = ({ form }: TSelectTypeProps) => {
  function handleUserType(e: RadioChangeEvent) {
    form.submit();
  }

  return (
    <SelectTypeWrapper>
      <Form name='select_type' form={form} layout='horizontal'>
        <Title level={2}>
          <span style={{ color: `${SecondaryColor}` }}>멘티</span>,{' '}
          <span style={{ color: `${PrimaryColor}` }}>멘토</span> 중<br />
          한가지를 선택해주세요.
        </Title>
        <Form.Item name='user_type' rules={[{ required: true, message: '타입을 선택해주세요' }]}>
          <Radio.Group onChange={handleUserType} style={{ width: '100%' }}>
            <Radio.Button className='mentee-type-button' value={EUserType.Mentee}>
              <Title level={3}>멘티</Title>
              <div className='user-type-content'>Professional firm 취업 준비를 위해 멘티로 가입합니다.</div>
            </Radio.Button>
            <Radio.Button className='mentor-type-button' value={EUserType.Mentor}>
              <Title level={3}>멘토</Title>
              <div className='user-type-content'>Professional firm 경력을 인증하고 멘토로 가입합니다.</div>
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Form>
    </SelectTypeWrapper>
  );
};

export default SelectType;
